import ReactApexChart from 'react-apexcharts'

const LineChart = ({ ratios, allYears, height, colors }) => {
  const options = {
    dataLabels: {
      enabled: true,
    },
    series: [
      {
        name: 'Ratio',
        data: ratios,
      },
    ],
    colors: colors,
    xaxis: {
      categories: allYears,
      title: {
        text: 'Year',
      },
    },
    chart: {
      height: 350,
      type: 'line',
      dropShadow: {
        enabled: false,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2,
      },
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    // tooltip: {
    //   y: {
    //     formatter: function (val) {
    //       return val;
    //     },
    //   },
    // },
  }
  return (
    <>
      {ratios?.length > 0 ? (
        <ReactApexChart
          options={options}
          series={options?.series}
          type='line'
          height={height}
        />
      ) : (
        <p>Nil Claims</p>
      )}
    </>
  )
}

export default LineChart
